import type { Perspective } from '../../../stores/perspectiveStore';
import type { GenogramAssistantRole } from './AssistantRole';

export interface GenogramAssistantRolePolicy {
  defaultViewpoint: Perspective;
  toolPriority: string[];
}

export const RENDERED_GENOGRAM_VIEWPOINTS: readonly Perspective[] = ['general', 'cultural', 'health'];

export const isRenderedGenogramViewpoint = (viewpoint: Perspective): boolean =>
  RENDERED_GENOGRAM_VIEWPOINTS.includes(viewpoint);

export const GENOGRAM_ASSISTANT_ROLE_POLICIES: Record<GenogramAssistantRole, GenogramAssistantRolePolicy> = {
  'family-therapist': {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_proposed_changes', 'genogram_analyze_report', 'genogram_viewpoint_set', 'genogram_fieldpack_enrich'],
  },
  'genetic-counselor': {
    defaultViewpoint: 'health',
    toolPriority: ['genogram_analyze_report', 'genogram_fieldpack_enrich', 'genogram_health_focus', 'genogram_proposed_changes'],
  },
  'case-worker': {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_analyze_report', 'genogram_proposed_changes', 'genogram_fieldpack_enrich', 'genogram_viewpoint_set'],
  },
  'legal-estate-planner': {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_analyze_report', 'genogram_proposed_changes', 'genogram_viewpoint_set', 'genogram_fieldpack_enrich'],
  },
  researcher: {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_analyze_report', 'genogram_fieldpack_enrich', 'genogram_proposed_changes', 'genogram_viewpoint_set'],
  },
  genealogist: {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_proposed_changes', 'genogram_analyze_report', 'genogram_viewpoint_set', 'genogram_fieldpack_enrich'],
  },
  educator: {
    defaultViewpoint: 'general',
    toolPriority: ['genogram_proposed_changes', 'genogram_viewpoint_set', 'genogram_analyze_report', 'genogram_fieldpack_enrich'],
  },
};

export const getDefaultViewpointForRole = (role: GenogramAssistantRole | null | undefined): Perspective | null => {
  if (!role) return null;
  return GENOGRAM_ASSISTANT_ROLE_POLICIES[role]?.defaultViewpoint ?? null;
};
